// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ElzUidPih9PAWhmRN7ww {
    background-color: white;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 16px;
}

.CvRVDCMFloDyR2qEhn2L {
    display: flex;
    flex-direction: column;
    flex: 3;
}

.zxqCpRzxtqEiUd9e_ib6 {
    margin-bottom: 16px;
}

.AuKLv834Ck6XGEh4gFt2 {
    flex: 1;
}

.OschddKJ3uixT1092ANy + .OschddKJ3uixT1092ANy {
    margin-top: 8px;
}

.pfamLxFjH_WEvvSx8NBC {
    margin-bottom: 4px;
}

.KV0XxJpZrUHRucwarXSF {
    border-radius: 3px;;
    border: 1px solid #ddd;
    color: #666;
    padding: 8px 8px;
}

.KV0XxJpZrUHRucwarXSF + .KV0XxJpZrUHRucwarXSF {
    margin-top: 4px;
}

.pyBSNr2PSdMy8yxVy1ct {
    align-items: flex-end;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;
}

.RgYqpOiNCGRzPYUCQ6CQ {
    cursor: pointer;
}

.RgYqpOiNCGRzPYUCQ6CQ:hover {
    color: black;
    border-color: #37B4C9;
}

.TL3OWyapmd5kN5YR6X77 {
    cursor: default;
    color: #999;
    font-style: italic;
    border-color: #eee;
}
`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/dashboard/components/content.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".sidebar {\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin-right: 16px;\n}\n\n.body {\n    display: flex;\n    flex-direction: column;\n    flex: 3;\n}\n\n.manualContact {\n    margin-bottom: 16px;\n}\n\n.groups {\n    flex: 1;\n}\n\n.group + .group {\n    margin-top: 8px;\n}\n\n.groupHeading {\n    margin-bottom: 4px;\n}\n\n.subgroup {\n    border-radius: 3px;;\n    border: 1px solid #ddd;\n    color: #666;\n    padding: 8px 8px;\n}\n\n.subgroup + .subgroup {\n    margin-top: 4px;\n}\n\n.controls {\n    align-items: flex-end;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n}\n\n.notEmpty {\n    cursor: pointer;\n}\n\n.notEmpty:hover {\n    color: black;\n    border-color: #37B4C9;\n}\n\n.empty {\n    cursor: default;\n    color: #999;\n    font-style: italic;\n    border-color: #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `ElzUidPih9PAWhmRN7ww`,
	"body": `CvRVDCMFloDyR2qEhn2L`,
	"manualContact": `zxqCpRzxtqEiUd9e_ib6`,
	"groups": `AuKLv834Ck6XGEh4gFt2`,
	"group": `OschddKJ3uixT1092ANy`,
	"groupHeading": `pfamLxFjH_WEvvSx8NBC`,
	"subgroup": `KV0XxJpZrUHRucwarXSF`,
	"controls": `pyBSNr2PSdMy8yxVy1ct`,
	"notEmpty": `RgYqpOiNCGRzPYUCQ6CQ`,
	"empty": `TL3OWyapmd5kN5YR6X77`
};
export default ___CSS_LOADER_EXPORT___;
